
import * as ipxRuntime$_0_V_NSxdI31LUQTb4tez7MLLVNWS3KW0W3bxqUZIiDw from '/opt/atlassian/pipelines/agent/build/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$_0_V_NSxdI31LUQTb4tez7MLLVNWS3KW0W3bxqUZIiDw, defaults: {} }
}
        